// @flow

import * as React from 'react';

import Container from '../Container/Container';
import './PageBody.scss';

type Props = {
  children: React.Node,
  expandContent?: boolean,
}

class PageBody extends React.Component<Props> {
  componentDidMount() {
    this.scrollToTop();
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  render() {
    const { expandContent, children } = this.props;
    return expandContent ? (
      <div className="page-body--expanded">
        {children}
      </div>
    ) : (
      <div className="page-body">
        <Container>
          {children}
        </Container>
      </div>
    );
  }
}

export default PageBody;
